import { Collapse, /* Icon, */ Alert } from 'antd';
import React, { useEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { CaretUpEmberIcon } from '../../../components/common/CustomIcon';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { noop } from 'lodash';

const { Panel } = Collapse;

function TuringCollapse ({ children, icon, spicon, title, hideEditInfo, className, active, service, name = 'panel', StatusBadgeComponent, StatusBadgeType, customIcon = false, onCollapseChange = noop }) {
  const { activeForm, completed, focusProject } = (service && service.state) || {};
  const { isReadOnly } = (service && service.props) || {};
  const isCompleted = completed ? completed[name] : true;

  const args = {};
  if (name !== 'panel') {
    args.activeKey = activeForm;
    args.onChange = ([isActive]) => {
      if (isActive) {
        service.onPanelSelect(name);
      } else if (activeForm === name) {
        service.onPanelSelect(null);
      }
    };
  } else {
    args.onChange = ([isActive]) => onCollapseChange(isActive);
  }

  useEffect(() => {
    if (focusProject && name === 'WorkHistory') {
      service.onPanelSelect('WorkHistory');
    }
  }, [focusProject]);

  const getExpandIcon = (item) => {
    // if (item.isActive) return <Icon width="24px" height="24px" style={customIcon ? { color: '#2E6EDF' } : {}} type="up" />;
    // return <Icon width="24px" height="24px" style={customIcon ? { color: '#2E6EDF' } : {}} type="down" />;
    if (item.isActive) return <ExpandLessIcon style={{ fontSize: 24, color: `${customIcon ? '#2E6EDF' : '#FFF'}` }}/>;
    return <ExpandMoreIcon style={{ fontSize: 16, color: `${customIcon ? '#2E6EDF' : '#1E1E1E'}` }}/>;
  };

  return (
    <Collapse defaultActiveKey={active ? name : ''} {...args} className={`TuringCollapse ${className}`} collapsible="header" bordered={false} expandIcon={getExpandIcon} expandIconPosition="right">
      <Panel header={(
        <div className="TuringCollapse-header">
          { icon ? <span className="material-icons" style={{ color: '#212121' }} aria-hidden="true">{icon}</span> : (spicon ? <div>{spicon}</div> : null) }
          <span className="TuringCollapse-title">{title}</span>
          {StatusBadgeComponent ? <span className="TuringCollapse-headerright"><StatusBadgeComponent type={StatusBadgeType}/> </span> : null}
          { !isCompleted ? <span><Alert className='resume-warning-alert' message="Missing Information" showIcon type='error' icon={<CaretUpEmberIcon className="resume-warning-icon" />} /></span> : (hideEditInfo || isReadOnly ? null : <span className={!customIcon ? 'TuringCollapse-headerright' : 'TuringCollapse-headerright custom-edit'}>Edit Information</span>)}
          {/* { isCompleted || isReadOnly ? null : <span><Alert className='resume-warning-alert' message="Missing Information" showIcon type='error' icon={<CaretUpEmberIcon className="resume-warning-icon" />} /></span>} */}
        </div>
      )} key={name}>
        { children }
      </Panel>
    </Collapse>
  );
}

export const TuringCollapseV2 = forwardRef(({ children, icon, spicon, title, hideEditInfo, className, active, service, name = 'panel', StatusBadgeComponent, StatusBadgeType, customIcon = false, onCollapseChange = noop }, ref) => {
  const { activeForm, completed, focusProject } = (service && service.state) || {};
  const { isReadOnly } = (service && service.props) || {};
  const isCompleted = completed ? completed[name] : true;
  const args = {};
  if (name !== 'panel') {
    args.activeKey = activeForm;
    args.onChange = ([isActive]) => {
      if (isActive) {
        service.onPanelSelect(name);
      } else if (activeForm === name) {
        service.onPanelSelect(null);
      }
    };
  } else {
    args.onChange = ([isActive]) => onCollapseChange(isActive);
  }

  useEffect(() => {
    if (focusProject && name === 'WorkHistory') {
      service.onPanelSelect('WorkHistory');
    }
  }, [focusProject]);

  const getExpandIcon = (item) => {
    if (item.isActive) return <ExpandLessIcon style={{ fontSize: 24, color: `${customIcon ? '#2E6EDF' : '#FFF'}` }}/>;
    return <ExpandMoreIcon style={{ fontSize: 16, color: `${customIcon ? '#2E6EDF' : '#1E1E1E'}` }}/>;
  };

  return (
    <div ref={ref}>
      <Collapse activeKey={active ? name : ''} {...args} className={`TuringCollapse ${className}`} collapsible="header" bordered={false} expandIcon={getExpandIcon} expandIconPosition="right">
        <Panel header={(
          <div className="TuringCollapse-header">
          { icon ? <span className="material-icons" style={{ color: '#212121' }} aria-hidden="true">{icon}</span> : (spicon ? <div>{spicon}</div> : null) }
          <span className="TuringCollapse-title">{title}</span>
          {StatusBadgeComponent ? <span className="TuringCollapse-headerright"><StatusBadgeComponent type={StatusBadgeType}/> </span> : null}
          { !isCompleted ? <span><Alert className='resume-warning-alert' message="Missing Information" showIcon type='error' icon={<CaretUpEmberIcon className="resume-warning-icon" />} /></span> : (hideEditInfo || isReadOnly ? null : <span className={!customIcon ? 'TuringCollapse-headerright' : 'TuringCollapse-headerright custom-edit'}>Edit Information</span>)}
        </div>
      )} key={name}>
        { children }
      </Panel>
      </Collapse>
    </div>
  );
})

TuringCollapseV2.displayName = 'TuringCollapseV2'; 



TuringCollapse.propTypes = {
  children: PropTypes.any,
  icon: PropTypes.any,
  spicon: PropTypes.any,
  hideEditInfo: PropTypes.any,
  className: PropTypes.any,
  active: PropTypes.bool,
  title: PropTypes.any,
  onChange: PropTypes.func,
  name: PropTypes.any,
  service: PropTypes.any,
  StatusBadgeComponent: PropTypes.any,
  StatusBadgeType: PropTypes.any,
  customIcon: PropTypes.bool,
  onCollapseChange: PropTypes.func
};

TuringCollapseV2.propTypes = {
  children: PropTypes.any,
  icon: PropTypes.any,
  spicon: PropTypes.any,
  hideEditInfo: PropTypes.any,
  className: PropTypes.any,
  active: PropTypes.bool,
  title: PropTypes.any,
  onChange: PropTypes.func,
  name: PropTypes.any,
  service: PropTypes.any,
  StatusBadgeComponent: PropTypes.any,
  StatusBadgeType: PropTypes.any,
  customIcon: PropTypes.bool,
  onCollapseChange: PropTypes.func
};

export default TuringCollapse;
